function MyProfilePage() {
  return <div>MyProfilePage</div>;
}

export default MyProfilePage;
